import { currentEnv, Environment } from '../../utils/env.utils'
import type { EventProperties } from './types'

// TypeScript declaration for Google Tag Manager's dataLayer
declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

class DataLayerService {
  /**
   * Initialize dataLayer if it doesn't exist
   */
  constructor() {
    if (!window.dataLayer) {
      window.dataLayer = []
    }
  }

  /**
   * Track an event by pushing to Google Tag Manager's dataLayer
   * Only tracks in production environment (not localhost and not staging)
   */
  track(eventName: string, properties?: EventProperties): void {
    if (currentEnv !== Environment.Production) {
      return
    }

    try {
      window.dataLayer?.push({
        event: eventName,
        ...properties,
      })
    } catch (error) {
      console.error('Failed to push event to dataLayer:', error)
    }
  }
}

export const dataLayerService = new DataLayerService()
